import {Pipe, PipeTransform} from '@angular/core';
import {BoulderListEntry} from '../model/boulder-list-entry';
import {SortType} from '../model/boulder-filter';

@Pipe({
  name: 'sort'
})
export class SortBoulderListPipe implements PipeTransform {

  constructor() {
  }

  private static compareDates(a: Date, b: Date, ascending: boolean) {
    let result = 0;

    if (a < b) {
      result = 1;
    } else if (b < a) {
      result = -1;
    }
    return ascending ? -1 * result : result;
  }

  private static compareNumbers(a: number, b: number, ascending: boolean) {
    let result = 0;
    if (a < b) {
      result = 1;
    } else if (b < a) {
      result = -1;
    }
    return ascending ? -1 * result : result;
  }

  public static sortBoulderList(boulderList: BoulderListEntry[], orderBy: SortType) {
    if (!boulderList || boulderList.length == 0) {
      return boulderList;
    }
    boulderList.sort((a: BoulderListEntry, b: BoulderListEntry) => {
      switch (orderBy) {
        case'grade-descending':
          return SortBoulderListPipe.compareNumbers(a.grade, b.grade, false);
        case'grade-ascending':
          return SortBoulderListPipe.compareNumbers(a.grade, b.grade, true);
        case'rating-descending':
          return SortBoulderListPipe.compareNumbers(a.rating, b.rating, false);
        case'date':
          return SortBoulderListPipe.compareDates(a.creationDate, b.creationDate, false);
        case'num-ascents-ascending':
          return SortBoulderListPipe.compareNumbers(a.numAscents, b.numAscents, true);
        case'num-ascents-descending':
          return SortBoulderListPipe.compareNumbers(a.numAscents, b.numAscents, false);
        default:
          return 0;
      }
    });
    return boulderList;
  }

  transform(boulderList: BoulderListEntry[], orderBy: SortType): any {
    return SortBoulderListPipe.sortBoulderList(boulderList, orderBy);
  }
}
